const footerLinks = {
  Producto: ['Características', 'Especificaciones', 'Preventa', 'FAQ'],
  Empresa: ['Sobre nosotros', 'Blog', 'Prensa', 'Contacto'],
  Legal: ['Privacidad', 'Términos de uso', 'Cookies'],
};

const Footer = () => (
  <footer className="bg-stone-950 text-white pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
        {/* Brand */}
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img
              src="https://static.readdy.ai/image/9bbec872eb58a17c0d56a007cba2726b/be68cadd3dfd5e837ffeaf266bc03c46.jpeg"
              alt="HELIX Ring"
              className="h-10 w-10 rounded-full object-cover"
            />
            <span className="font-display text-2xl font-semibold tracking-widest text-white">
              HELIX
            </span>
          </div>
          <p className="text-stone-400 text-sm leading-relaxed font-body max-w-xs">
            El anillo inteligente que transforma cómo entiendes tu cuerpo.
            Diseño premium. Tecnología de precisión. Tu salud en el centro.
          </p>
          <div className="flex items-center gap-4 mt-6">
            {['ri-instagram-line', 'ri-twitter-x-line', 'ri-tiktok-line', 'ri-youtube-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-700 text-stone-400 hover:text-amber-400 hover:border-amber-700 transition-colors duration-200 cursor-pointer"
                rel="nofollow"
              >
                <i className={`${icon} text-base`} />
              </a>
            ))}
          </div>
        </div>

        {/* Links */}
        {Object.entries(footerLinks).map(([category, links]) => (
          <div key={category}>
            <h5 className="font-body text-xs font-semibold tracking-widest text-stone-400 uppercase mb-5">
              <a href="#" className="hover:text-amber-400 transition-colors">{category}</a>
            </h5>
            <ul className="flex flex-col gap-3">
              {links.map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    rel="nofollow"
                    className="font-body text-sm text-stone-300 hover:text-amber-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-body text-xs text-stone-500">
          © 2025 HELIX Ring. Todos los derechos reservados.
        </p>
        <p className="font-body text-xs text-stone-500 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-500 inline-block" />
          Fabricado con precisión. Diseñado para durar.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
